@if (show) {
<footer class="footer section is-medium">
  <div class="container is-fluid">
    <div class="footer__row row--top">
      <div class="columns">
        <div class="column">
          <div class="footer__logo">
            <a routerLink="/">
              <img src="assets/logos/Zambezi_Wordmark.svg" alt="zambezi logo">
            </a>
          </div><br />
          <div class="footer__logos">
            <a href="https://www.scalebyzmbz.com/" target="_blank" rel="noopener noreferrer">
              <img class="logo logo--scale" width="65" height="17" src="assets/logos/scale-logo.svg" alt="scale logo" />
            </a>
            <span><img src="../../../../assets/icons/footer-divider.svg" alt="divider" /></span>
            <a href="https://www.finstudios-la.com/" target="_blank" rel="noopener noreferrer">
              <img class="logo logo--fin" width="41" height="27" src="assets/logos/fin-logo.svg" alt="fin logo">
            </a>
            <!-- <span><img src="../../../../assets/icons/footer-divider.svg" alt="divider" /></span>
            <a href="https://www.instagram.com/zmbzagency/" target="_blank" rel="noopener noreferrer">
              <img class="logo logo--school" width="83" height="20" src="assets/logos/school-logo.svg"
                alt="school logo">
            </a> -->
          </div>
        </div>
        <div class="column column--forms">
          <app-email-signup
            [portalId]="portalId"
            [formId]="formId" />
        </div>
      </div>
    </div>
    <div class="footer__row row--bottom">
      <div class="columns">
        <div class="column">
          ZMBZ WEST<br />
          3522 Hayden Ave<br />
          Culver City, CA 90232<br />
          USA
        </div>
        <div class="column">
          ZMBZ NORTH<br />
          124 3rd Ave N, Suite 302<br />
          Minneapolis, MN 55401<br />
          USA
        </div>
        <div class="column footer__partner">
          PARTNER WITH US<br />
          newbusiness&#64;zmbz.com <br />
          310.450.6800
        </div>
        <div class="column footer__links">
          <a class="menu__item" routerLink="/terms-of-use" routerLinkActive="active">Terms of Use</a>
          <a class="menu__item" routerLink="/privacy-policy" routerLinkActive="active">Privacy Policy</a>
        </div>
        <div class="column footer__social">
          <a href="https://www.instagram.com/zmbzagency/" target="_blank" rel="noopener noreferrer"
            class="footer__social-link">INSTAGRAM</a>
          <a href="https://www.tiktok.com/@zmbzagency" target="_blank" rel="noopener noreferrer"
            class="footer__social-link">TIKTOK</a>
          <a href="https://twitter.com/zmbzagency/" target="_blank" rel="noopener noreferrer"
            class="footer__social-link">TWITTER</a>
          <a href="https://www.linkedin.com/company/zmbz/" target="_blank" rel="noopener noreferrer"
            class="footer__social-link">LINKEDIN</a>
          <a href="https://www.facebook.com/zmbzagency/" target="_blank" rel="noopener noreferrer"
            class="footer__social-link">FACEBOOK</a>
        </div>
      </div>
      <p class="legal">©{{currentYear}} Zambezi</p>
    </div>
  </div>
</footer>
}
